import React from 'react';
import {
  Box,
  Container,
  SimpleGrid,
  Text,
  Heading,
  Link,
  HStack,
  VStack,
  Flex,
  Divider,
  Icon,
  Button,
  useColorModeValue,
  List,
  ListItem,
  ListIcon,
  Link as ChakraLink,
  Center,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Image,
  useDisclosure,
} from '@chakra-ui/react';
import { FaGithub, FaTwitter, FaLinkedin, FaArrowRight, FaCheck, FaWeixin, FaTrophy, FaEnvelope } from 'react-icons/fa';
import { Link as RouterLink } from 'react-router-dom';

const Footer: React.FC = () => {
  const bgColor = useColorModeValue('gray.50', 'gray.900');
  const borderColor = useColorModeValue('gray.200', 'gray.700');
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <Box
      as="footer"
      bg={bgColor}
      py={20}
      borderTop="1px"
      borderTopColor={borderColor}
      position="relative"
      overflow="hidden"
    >
      {/* 装饰元素 */}
      <Box
        position="absolute"
        width="500px"
        height="500px"
        borderRadius="full"
        bgGradient="radial-gradient(circle, rgba(124,58,237,0.03) 0%, rgba(124,58,237,0) 70%)"
        bottom="-250px"
        right="-100px"
        zIndex={0}
      />

      <Container maxW="1200px" position="relative" zIndex={1}>
        {/* 服务范围区域 */}
        <Box mb={16}>
          <SimpleGrid columns={{ base: 1, md: 4 }} spacing={{ base: 10, md: 8 }}>
            <VStack align="flex-start" spacing={6}>
              <Text fontSize="2xl" fontWeight="bold" bgGradient="linear(to-r, brand.purple, purple.500)" bgClip="text">
                Y-Square AI
              </Text>
              <Text color="gray.600" lineHeight="tall">
                我们是专注于人工智能研发与服务的创新企业，致力于为各行业提供先进的AI解决方案，助力企业数字化转型。
              </Text>
              <Button
                as={RouterLink}
                to="/about"
                rightIcon={<FaArrowRight />}
                size="md"
                variant="outline"
                colorScheme="purple"
                _hover={{
                  transform: "translateX(4px)",
                  transition: "transform 0.3s ease"
                }}
              >
                了解更多
              </Button>
            </VStack>

            <VStack align="flex-start" spacing={4}>
              <Heading
                as="h3"
                size="sm"
                color="brand.purple"
                fontWeight="bold"
                pb={2}
                borderBottom="2px solid"
                borderBottomColor="brand.purple"
                width="fit-content"
              >
                核心技术
              </Heading>
              <List spacing={2}>
                <ListItem>
                  <ListIcon as={FaCheck} color="brand.purple" />
                  <ChakraLink as={RouterLink} to="/tech" color="gray.600" _hover={{ color: "brand.purple" }} fontWeight="medium" transition="all 0.2s">自然语言处理</ChakraLink>
                </ListItem>
                <ListItem>
                  <ListIcon as={FaCheck} color="brand.purple" />
                  <ChakraLink as={RouterLink} to="/tech" color="gray.600" _hover={{ color: "brand.purple" }} fontWeight="medium" transition="all 0.2s">机器学习与深度学习</ChakraLink>
                </ListItem>
                <ListItem>
                  <ListIcon as={FaCheck} color="brand.purple" />
                  <ChakraLink as={RouterLink} to="/tech" color="gray.600" _hover={{ color: "brand.purple" }} fontWeight="medium" transition="all 0.2s">计算机视觉</ChakraLink>
                </ListItem>
                <ListItem>
                  <ListIcon as={FaCheck} color="brand.purple" />
                  <ChakraLink as={RouterLink} to="/tech" color="gray.600" _hover={{ color: "brand.purple" }} fontWeight="medium" transition="all 0.2s">知识图谱</ChakraLink>
                </ListItem>
                <ListItem>
                  <ListIcon as={FaCheck} color="brand.purple" />
                  <ChakraLink as={RouterLink} to="/tech" color="gray.600" _hover={{ color: "brand.purple" }} fontWeight="medium" transition="all 0.2s">智能推荐系统</ChakraLink>
                </ListItem>
              </List>
            </VStack>

            <VStack align="flex-start" spacing={4}>
              <Heading
                as="h3"
                size="sm"
                color="brand.purple"
                fontWeight="bold"
                pb={2}
                borderBottom="2px solid"
                borderBottomColor="brand.purple"
                width="fit-content"
              >
                解决方案
              </Heading>
              <List spacing={2}>
                <ListItem>
                  <ListIcon as={FaCheck} color="brand.purple" />
                  <ChakraLink as={RouterLink} to="/solutions" color="gray.600" _hover={{ color: "brand.purple" }} fontWeight="medium" transition="all 0.2s">智能客服系统</ChakraLink>
                </ListItem>
                <ListItem>
                  <ListIcon as={FaCheck} color="brand.purple" />
                  <ChakraLink as={RouterLink} to="/solutions" color="gray.600" _hover={{ color: "brand.purple" }} fontWeight="medium" transition="all 0.2s">预测分析平台</ChakraLink>
                </ListItem>
                <ListItem>
                  <ListIcon as={FaCheck} color="brand.purple" />
                  <ChakraLink as={RouterLink} to="/solutions" color="gray.600" _hover={{ color: "brand.purple" }} fontWeight="medium" transition="all 0.2s">智能识别系统</ChakraLink>
                </ListItem>
                <ListItem>
                  <ListIcon as={FaCheck} color="brand.purple" />
                  <ChakraLink as={RouterLink} to="/solutions" color="gray.600" _hover={{ color: "brand.purple" }} fontWeight="medium" transition="all 0.2s">内容生成与推荐</ChakraLink>
                </ListItem>
                <ListItem>
                  <ListIcon as={FaCheck} color="brand.purple" />
                  <ChakraLink as={RouterLink} to="/solutions" color="gray.600" _hover={{ color: "brand.purple" }} fontWeight="medium" transition="all 0.2s">智能决策支持</ChakraLink>
                </ListItem>
              </List>
            </VStack>

            <VStack align="flex-start" spacing={4}>
              <Heading
                as="h3"
                size="sm"
                color="brand.purple"
                fontWeight="bold"
                pb={2}
                borderBottom="2px solid"
                borderBottomColor="brand.purple"
                width="fit-content"
              >
                合作与支持
              </Heading>
              <List spacing={2}>
                <ListItem>
                  <ListIcon as={FaCheck} color="brand.purple" />
                  <ChakraLink as={RouterLink} to="/contact" color="gray.600" _hover={{ color: "brand.purple" }} fontWeight="medium" transition="all 0.2s">技术咨询</ChakraLink>
                </ListItem>
                <ListItem>
                  <ListIcon as={FaCheck} color="brand.purple" />
                  <ChakraLink as={RouterLink} to="/contact" color="gray.600" _hover={{ color: "brand.purple" }} fontWeight="medium" transition="all 0.2s">定制开发</ChakraLink>
                </ListItem>
                <ListItem>
                  <ListIcon as={FaCheck} color="brand.purple" />
                  <ChakraLink as={RouterLink} to="/contact" color="gray.600" _hover={{ color: "brand.purple" }} fontWeight="medium" transition="all 0.2s">培训服务</ChakraLink>
                </ListItem>
                <ListItem>
                  <ListIcon as={FaCheck} color="brand.purple" />
                  <ChakraLink as={RouterLink} to="/contact" color="gray.600" _hover={{ color: "brand.purple" }} fontWeight="medium" transition="all 0.2s">技术支持</ChakraLink>
                </ListItem>
                <ListItem>
                  <ListIcon as={FaCheck} color="brand.purple" />
                  <ChakraLink as={RouterLink} to="/contact" color="gray.600" _hover={{ color: "brand.purple" }} fontWeight="medium" transition="all 0.2s">合作伙伴计划</ChakraLink>
                </ListItem>
              </List>
            </VStack>
          </SimpleGrid>
        </Box>

        <Divider my={8} borderColor={borderColor} />

        {/* 社交媒体链接 */}
        <Flex
          justify="space-between"
          align="center"
          flexWrap={{ base: "wrap", md: "nowrap" }}
          gap={{ base: 4, md: 0 }}
        >
          <Flex direction="column" gap={2}>
            <Text fontSize="lg" fontWeight="bold" bgGradient="linear(to-r, brand.purple, brand.blue)" bgClip="text">
              元垚科技
            </Text>
            <Text color="gray.500" fontSize="sm">© 2024 元垚科技. 保留所有权利。</Text>
          </Flex>

          <HStack spacing={6} mt={{ base: 4, md: 0 }}>
            <ChakraLink
              onClick={onOpen}
              display="flex"
              alignItems="center"
              justifyContent="center"
              boxSize="40px"
              borderRadius="full"
              bg="gray.100"
              color="brand.purple"
              transition="all 0.3s ease"
              _hover={{
                bg: "brand.purple",
                color: "white",
                transform: "translateY(-2px)",
                boxShadow: "0 4px 10px rgba(124, 58, 237, 0.3)"
              }}
              title="微信"
              cursor="pointer"
            >
              <Icon as={FaWeixin} boxSize={5} />
            </ChakraLink>
            <ChakraLink
              href="mailto:y_square_biz@163.com"
              display="flex"
              alignItems="center"
              justifyContent="center"
              boxSize="40px"
              borderRadius="full"
              bg="gray.100"
              color="brand.purple"
              transition="all 0.3s ease"
              _hover={{
                bg: "brand.purple",
                color: "white",
                transform: "translateY(-2px)",
                boxShadow: "0 4px 10px rgba(124, 58, 237, 0.3)"
              }}
              title="联系邮箱"
            >
              <Icon as={FaEnvelope} boxSize={5} />
            </ChakraLink>
          </HStack>
        </Flex>

        {/* 备案信息 */}
        <Center mt={8} pt={6} borderTop="1px solid" borderTopColor={borderColor}>
          <HStack spacing={2} color="gray.500" fontSize="xs" flexWrap="wrap" justifyContent="center">
            <Link href="https://beian.miit.gov.cn/" isExternal color="gray.500" _hover={{ color: "brand.purple" }}>
              粤ICP备2024315634号-1
            </Link>
            {/* <Box as="span" display={{ base: 'none', sm: 'inline' }}> | </Box>
            <Link href="http://www.beian.gov.cn/" isExternal color="gray.500" _hover={{ color: "brand.purple" }}>
              粤公网安备XXXXXXXX号
            </Link> */}
          </HStack>
        </Center>
      </Container>

      {/* 微信二维码弹窗 */}
      <Modal isOpen={isOpen} onClose={onClose} isCentered size="md">
        <ModalOverlay backdropFilter="blur(5px)" />
        <ModalContent borderRadius="xl" boxShadow="xl">
          <ModalHeader textAlign="center" color="brand.purple">添加我们的微信</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <Center>
              <Image
                src="/wechat-qr-code.png"
                alt="微信二维码"
                boxSize="300px"
                objectFit="contain"
                borderRadius="lg"
                fallbackSrc="https://via.placeholder.com/300?text=微信二维码"
              />
            </Center>
            <Text textAlign="center" mt={4} color="gray.600" fontSize="sm">
              扫描上方二维码，添加我们的微信
            </Text>
          </ModalBody>
          <ModalFooter justifyContent="center">
            <Button colorScheme="purple" onClick={onClose}>关闭</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default Footer;